import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { LOGIN_ADMIN } from "URLRoutes";
import CommonTextField from "components/InterstellrComponents/CommonTextField";
import FilledButton from "components/InterstellrComponents/FilledButton";

const LoginForm = () => {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const onSubmit = async () => {
    await axios
      .post(LOGIN_ADMIN, {
        email: username,
        password: password,
      })
      .then(async (response) => {
        if (response?.data?.success == false) {
          return alert(response?.data?.message ?? "");
        }

        localStorage.setItem("accessToken", response?.data?.data?.token);
        navigate("/admin/dashboard");
      })
      .catch((error) => {
        console.log("Login Error: ", error);
        return alert(error);
      });
  };

  return (
    <>
      <CommonTextField
        title={"Email Address"}
        placeholder={"Admin Email Address"}
        type="email"
        value={username}
        onChange={setUsername}
      />

      <CommonTextField
        title={"Password"}
        placeholder={"Password"}
        type="password"
        value={password}
        onChange={setPassword}
      />

      <FilledButton text={"Login to Mind Pulse"} onPress={onSubmit} />
    </>
  );
};

export default LoginForm;
